<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  #app {
  }
</style>



// WEBPACK FOOTER //
// src/App.vue